<!-- 1. 共通テストカウントダウンバナー -->
<app-common-id-exam-countdown-banner (viewKakomonClick)="onViewKakomonClick()"></app-common-id-exam-countdown-banner>

<!-- ============================================ -->
<!-- 2. 4つのグリッドメニュー -->
<!-- ============================================ -->
<app-wrapper size="lg">
  <app-content-row>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
      <!-- 大学から探す -->
      <button
        class="bg-white rounded-lg border border-gray-50 py-3 px-3 md:py-4 md:px-4 text-left hover:bg-primary/5 transition-colors duration-200 cursor-pointer flex flex-col items-start"
        (click)="onMenuClick('search-univ')"
      >
        <mat-icon class="text-primary text-[2rem] md:text-[2.5rem] size-8 md:size-10 mb-2" aria-hidden="true">location_city</mat-icon>
        <div class="font-bold text-base md:text-lg lg:text-xl">大学から探す</div>
        <div class="text-sm text-sub mt-3">大学名や大学の所在地から過去問を検索</div>
      </button>

      <!-- 分野から探す -->
      <button
        class="bg-white rounded-lg border border-gray-50 py-3 px-3 md:py-4 md:px-4 text-left hover:bg-primary/5 transition-colors duration-200 cursor-pointer flex flex-col items-start"
        (click)="onMenuClick('search-by-categories')"
      >
        <mat-icon class="text-primary text-[2rem] md:text-[2.5rem] size-8 md:size-10 mb-2" aria-hidden="true">manage_search</mat-icon>
        <div class="font-bold text-base md:text-lg lg:text-xl">分野から探す</div>
        <div class="text-sm text-sub mt-3">科目ごとの分野学習に最適</div>
      </button>

      <!-- おすすめ問題セット -->
      <button
        class="bg-white rounded-lg border border-gray-50 py-3 px-3 md:py-4 md:px-4 text-left hover:bg-primary/5 transition-colors duration-200 cursor-pointer flex flex-col items-start"
        (click)="onMenuClick('playlists')"
      >
        <mat-icon class="text-primary text-[2rem] md:text-[2.5rem] size-8 md:size-10 mb-2" aria-hidden="true">view_module</mat-icon>
        <div class="font-bold text-base md:text-lg lg:text-xl">おすすめ問題セット</div>
        <div class="text-sm text-sub mt-3">テーマごとの演習ができる問題セット</div>
      </button>

      <!-- マイリスト -->
      <button
        class="bg-white rounded-lg border border-gray-50 py-3 px-3 md:py-4 md:px-4 text-left hover:bg-primary/5 transition-colors duration-200 cursor-pointer flex flex-col items-start"
        (click)="onMenuClick('mylist')"
      >
        <mat-icon
          class="text-primary text-[2rem] md:text-[2.5rem] size-8 md:size-10 mb-2"
          aria-hidden="true"
          fontSet="material-icons-outlined"
        >
          fact_check
        </mat-icon>
        <div class="font-bold text-base md:text-lg lg:text-xl">マイリスト</div>
        <div class="text-sm text-sub mt-3">保存した問題や解答済みの問題を確認</div>
      </button>
    </div>
  </app-content-row>
</app-wrapper>

<!-- ============================================ -->
<!-- 3. あなたの志望校 -->
<!-- ============================================ -->
<app-wrapper size="lg" isFitWithSmallScreen="true">
  <app-content-row>
    <app-card-content [showSeparator]="true">
      <app-card-content-head>
        <mat-icon class="card-content-head-icon">flag</mat-icon>
        あなたの志望校
        <div class="card-content-head-util">
          <app-popover #managementPopover placement="bottom-end" [offset]="2" [closeOnOutsideClick]="true">
            <button mat-flat-button class="bg-gray-50 text-sm !px-3" popoverTrigger [disabled]="isSyncing">
              <ng-container *ngIf="!isSyncing">
                <mat-icon class="text-primary text-base mr-1">settings</mat-icon>
                <span class="text-gray-700">管理</span>
                <mat-icon class="text-base text-gray-700">arrow_drop_down</mat-icon>
              </ng-container>
              <mat-icon *ngIf="isSyncing" class="text-primary text-base size-4 sync-spinning">sync</mat-icon>
            </button>
            <div popoverContent class="-m-3 py-1">
              <a
                class="flex items-center px-4 py-2 hover:bg-gray-30 cursor-pointer text-md font-normal"
                (click)="goToManabiProfile(); managementPopover.close()"
              >
                <mat-icon class="text-primary text-base size-4 mr-1.5">manage_accounts</mat-icon>
                <span>まなびIDで志望校の編集</span>
              </a>
              <a
                class="flex items-center px-4 py-2 hover:bg-gray-30 cursor-pointer text-md font-normal"
                (click)="onSyncShibokoClick(); managementPopover.close()"
              >
                <mat-icon class="text-primary text-base size-4 mr-1.5">sync</mat-icon>
                <span>最新の設定を反映</span>
              </a>
            </div>
          </app-popover>
        </div>
      </app-card-content-head>

      <app-wrapper size="fluid">
        <!-- ============================================ -->
        <!-- ▼▼▼ 志望校データがある場合 ここから ▼▼▼ -->
        <!-- ============================================ -->
        <div *ngIf="isRegistered">
          <div *ngIf="!isLoading; else loadingProgress">
            <app-content-row>
              <!-- 志望校カードグリッド -->
              <div class="grid grid-cols-1 xs:grid-cols-2 lg:grid-cols-3 gap-4">
                <div *ngFor="let univ of universities" class="rounded-lg border-2 border-gray-50 bg-white p-5">
                  <div class="flex items-center gap-2 mb-3 min-w-0">
                    <app-univ-cat-mark
                      [univCatType]="univ.univTypeName"
                      [univCatPref]="univ.prefName"
                      [univType]="univ.univType"
                    ></app-univ-cat-mark>
                    <span class="font-bold text-xl xs:text-lg truncate py-0.5">{{ univ.name }}</span>
                  </div>
                  <div class="flex items-center gap-2">
                    <button
                      *ngIf="univ.hasKakomon"
                      mat-flat-button
                      color="primary"
                      class="text-sm flex-1"
                      (click)="onKakomonClick(univ.id)"
                    >
                      過去問を解く
                    </button>
                    <button *ngIf="!univ.hasKakomon" mat-flat-button disabled class="!bg-gray-50 !text-sub text-xs flex-1 truncate">
                      この大学の過去問はございません
                    </button>
                    <app-popover placement="bottom-start" [offset]="2" [closeOnOutsideClick]="true">
                      <button mat-flat-button class="bg-gray-50 text-primary font-normal text-sm" popoverTrigger>
                        入試情報 <mat-icon class="text-base">arrow_drop_down</mat-icon>
                      </button>
                      <div popoverContent class="-m-3 py-1">
                        <a
                          class="flex items-center justify-between px-4 py-2 hover:bg-gray-30 cursor-pointer text-md font-normal"
                          [href]="getPassnaviUrl(univ.id, 'subject')"
                          target="_blank"
                          rel="noopener"
                        >
                          <span>入試科目・配点</span>
                          <mat-icon class="text-passnavi-primary text-base size-4 ml-1.5">open_in_new</mat-icon>
                        </a>
                        <a
                          class="flex items-center justify-between px-4 py-2 hover:bg-gray-30 cursor-pointer text-md font-normal"
                          [href]="getPassnaviUrl(univ.id, 'difficulty')"
                          target="_blank"
                          rel="noopener"
                        >
                          <span>偏差値・共テ得点率</span>
                          <mat-icon class="text-passnavi-primary text-base size-4 ml-1.5">open_in_new</mat-icon>
                        </a>
                        <a
                          class="flex items-center justify-between px-4 py-2 hover:bg-gray-30 cursor-pointer text-md font-normal"
                          [href]="getPassnaviUrl(univ.id, 'top')"
                          target="_blank"
                          rel="noopener"
                        >
                          <span>大学情報ページ</span>
                          <mat-icon class="text-passnavi-primary text-base size-4 ml-1.5">open_in_new</mat-icon>
                        </a>
                      </div>
                    </app-popover>
                  </div>
                </div>
              </div>
            </app-content-row>

            <!-- パスナビリンク -->
            <app-content-row>
              <div class="bg-gray-30 rounded-lg">
                <div class="flex items-center justify-center gap-3 px-3 py-2 md:px-4 md:py-2">
                  <img
                    width="88"
                    height="30"
                    class="w-[58px] sm:w-[88px]"
                    src="/assets/images/brand-logo-pathnavi.svg"
                    alt="旺文社パスナビ"
                  />
                  <p class="mb-0 text-sub text-xs sm:text-sm">旺文社パスナビの入試情報を掲載しています。</p>
                </div>
              </div>
            </app-content-row>
          </div>
          <ng-template #loadingProgress>
            <div class="spinner-spacer">
              <div class="progress-48">
                <mat-spinner [diameter]="48"></mat-spinner>
              </div>
            </div>
          </ng-template>
        </div>

        <!-- ============================================ -->
        <!-- ▲▲▲ 志望校データがある場合 ここまで ▲▲▲ -->
        <!-- ============================================ -->

        <!-- ============================================ -->
        <!-- ▼▼▼ 志望校データがない場合（ノーデータ） ここから ▼▼▼ -->
        <!-- ============================================ -->
        <div *ngIf="!isRegistered">
          <app-content-row>
            <app-content-no-data>
              <div class="flex flex-col md:flex-row items-center justify-center w-9/12 mx-auto my-4">
                <div class="md:w-1/2 text-center leading-relaxed">
                  <mat-icon class="text-sub text-[2.5rem] size-10 mb-2">flag</mat-icon>
                  <p class="text-md md:text-lg font-bold">まなびIDで志望校を登録しよう</p>
                  <p class="text-sm md:text-md my-4 text-sub">
                    志望校を登録すると&hellip;
                  </p>
                  <div class="text-left inline-block text-sm md:text-md mb-6">
                    <div class="flex items-center gap-2 mb-1">
                      <mat-icon class="text-base size-4">check_circle</mat-icon>
                      <span>志望校の過去問にクイックアクセス</span>
                    </div>
                    <div class="flex items-center gap-2">
                      <mat-icon class="text-base size-4">check_circle</mat-icon>
                      <span>科目・配点など入試情報をすぐに確認</span>
                    </div>
                  </div>
                  <div>
                    <button mat-flat-button class="bg-gray-50 text-primary font-normal" (click)="goToManabiProfile()">
                      まなびIDで志望校を登録
                      <mat-icon class="text-base ml-1">open_in_new</mat-icon>
                    </button>
                  </div>
                </div>
                <div class="md:w-1/2 mt-4 md:mt-0">
                  <img class="pointer-events-none max-w-full h-auto" src="assets/images/shiboko-example@2x.png" alt="" />
                </div>
              </div>
            </app-content-no-data>
          </app-content-row>
        </div>
        <!-- ============================================ -->
        <!-- ▲▲▲ 志望校データがない場合（ノーデータ） ここまで ▲▲▲ -->
        <!-- ============================================ -->
      </app-wrapper>
    </app-card-content>
  </app-content-row>
</app-wrapper>
